const PREFIX = '[WIKI-Front]';

type LogLevel = 'log' | 'info' | 'warn' | 'error';

const levels: Record<string, number> = { error: 0, warn: 1, info: 2, log: 3, debug: 4 };

function shouldLog(level: LogLevel): boolean {
  const logLevel = window.APP_CONFIG?.LOG_LEVEL ?? '';
  const min = (levels[logLevel] ?? levels.info) ?? 2;
  return (levels[level] ?? 2) <= min;
}

function formatArgs(args: unknown[]): unknown[] {
  return args.map((a) => (typeof a === 'object' ? tryJSON(a) : a));
}

function tryJSON(val: unknown): unknown {
  try {
    return JSON.parse(JSON.stringify(val));
  } catch {
    return val;
  }
}

function timestamp(): string {
  return new Date().toISOString().slice(11, 23);
}

export const logger = {
  request(method: string, url: string, data?: unknown) {
    if (!shouldLog('info')) return;
    const line = `${timestamp()} ${PREFIX} → ${method} ${url}`;
    if (data !== undefined) {
      console.log(line, formatArgs([data]));
    } else {
      console.log(line);
    }
  },

  response(method: string, url: string, status: number, durationMs: number) {
    if (!shouldLog('info')) return;
    const level = status >= 500 ? 'error' : status >= 400 ? 'warn' : 'info';
    const fn = console[level] ?? console.log;
    fn(`${timestamp()} ${PREFIX} ← ${method} ${url} ${status} (${durationMs}ms)`);
  },

  info(...args: unknown[]) {
    if (!shouldLog('info')) return;
    console.info(`${timestamp()} ${PREFIX}`, ...formatArgs(args));
  },

  warn(...args: unknown[]) {
    if (!shouldLog('warn')) return;
    console.warn(`${timestamp()} ${PREFIX}`, ...formatArgs(args));
  },

  error(context: string, err: unknown) {
    if (!shouldLog('error')) return;
    const detail = err instanceof Error ? { message: err.message, stack: err.stack } : err;
    console.error(`${timestamp()} ${PREFIX} [ERROR] ${context}`, formatArgs([detail]));
  },
};
